import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getFirebaseConfig } from './firebaseConfig.js';

export const getFirebaseApp = (): FirebaseApp | undefined => {
  const existing = getApps().length > 0 ? getApps()[0] : undefined;
  if (existing) return existing;

  const config = getFirebaseConfig();
  if (!config.apiKey || !config.projectId) {
    return undefined;
  }

  try {
    return initializeApp(config);
  } catch {
    return undefined;
  }
};

export const firebaseApp = getFirebaseApp();
